import {
  NavItemChildConfig,
  NavItemWithChildren,
} from '@app/components/layout/sidenav/link/NavItemWithChildren';
import { StationIcon } from '@app/components/stations/StationIcon';
import { useHasPermission } from '@app/core/auth/authorization/hooks/useHasPermission';
import { useDefaultStation } from '@app/core/stations/hooks/useDefaultStation';
import { useDefaultYoutubeNativeStation } from '@app/core/stations/hooks/useDefaultYoutubeNativeStation';
import { useYoutubeNativeStations } from '@app/core/stations/hooks/useYoutubeNativeStations';
import { defineMessage, useIntl } from 'react-intl';
import { LoggerIcon } from './LoggerIcon';
import { youtubeBroadcastsListRouteGenerator } from './screens/stream/youtube/broadcasts/list/youtube-broadcasts-list-routes';

const panoramaLabelMessage = defineMessage({
  id: 'logger.sidenav.panorama',
  defaultMessage: 'Panorama',
});

const reportesLabelMessage = defineMessage({
  id: 'logger.sidenav.reportes',
  defaultMessage: 'Reportes',
});

const youtubeLabelMessage = defineMessage({
  id: 'logger.sidenav.youtube',
  defaultMessage: 'YouTube',
});

/** Users-authz permission for viewing stream quality reports under Logger. */
// FIXME: use consts when exposed by the client
const STREAM_QUALITY_REPORT_VIEW_PERMISSION = 'stream-analysis:stream-quality:report-view';

export function LoggerLinks() {
  const { $t } = useIntl();

  const loggerLabel = $t({
    id: 'logger.navLabel',
    defaultMessage: 'Logger',
  });

  const defaultStation = useDefaultStation();
  const youtubeNativeStations = useYoutubeNativeStations();
  const defaultYoutubeNativeStation = useDefaultYoutubeNativeStation();
  const loggerReportsEnabled = useHasPermission(STREAM_QUALITY_REPORT_VIEW_PERMISSION);

  const children: NavItemChildConfig[] = [
    {
      label: defaultStation.name,
      to: `/logger/s/${defaultStation.slug}`,
      icon: <StationIcon fontSize="inherit" />,
    },
    {
      label: $t(panoramaLabelMessage),
      to: '/logger/status',
    },
  ];

  if (youtubeNativeStations.length > 0 && defaultYoutubeNativeStation) {
    children.push({
      label: $t(youtubeLabelMessage),
      to: youtubeBroadcastsListRouteGenerator.list(defaultYoutubeNativeStation.slug),
      isActive: (pathname) => pathname.startsWith('/youtube-broadcasts'),
    });
  }

  if (loggerReportsEnabled) {
    children.push({
      label: $t(reportesLabelMessage),
      to: '/logger/reports',
    });
  }

  return (
    <NavItemWithChildren
      root="/logger"
      additionalRoots={youtubeNativeStations.length > 0 ? ['/youtube-broadcasts'] : undefined}
      label={loggerLabel}
      icon={<LoggerIcon />}
      items={children}
    />
  );
}
